import { store } from '@/store';

export const copyShaft = (payload, isUpdate, includeBase, includeBuildup) => {
  var shaft = {};
  if (isUpdate) shaft.id = payload.id;
  shaft.title = payload.title;
  shaft.site_id = payload.site_id;
  if (shaft.site_id.id) shaft.site_id = shaft.site_id.id;

  // base properties
  if (includeBase) {
    shaft.type = payload.type;
    if (shaft.type && shaft.type.id) shaft.type = shaft.type.id;
    shaft.subtype = payload.subtype;
    shaft.anchor = payload.anchor;
    shaft.slope = payload.slope;
  } else {
    shaft.type = null;
    shaft.subtype = null;
    shaft.anchor = null;
    shaft.slope = 0;
  }

  // input channel
  if (includeBase) {
    shaft.input_channel = { ...payload.input_channel };
    if (shaft.input_channel) {
      if (!isUpdate) delete shaft.input_channel.id;
      delete shaft.input_channel.user_created;
      if (shaft.input_channel.diameter && shaft.input_channel.diameter.id)
        shaft.input_channel.diameter = shaft.input_channel.diameter.id;
      if (shaft.input_channel.angle === '')
        shaft.input_channel.angle = undefined;
    }
  } else shaft.input_channel = null;

  // output channel
  if (includeBase) {
    shaft.output_channel = { ...payload.output_channel };
    if (shaft.output_channel) {
      if (!isUpdate) delete shaft.output_channel.id;
      delete shaft.output_channel.user_created;
      if (shaft.output_channel.diameter && shaft.output_channel.diameter.id)
        shaft.output_channel.diameter = shaft.output_channel.diameter.id;
      if (shaft.output_channel.angle === '')
        shaft.output_channel.angle = undefined;
    }
  } else shaft.output_channel = null;

  // side channels
  if (includeBase && payload.side_channels) {
    shaft.side_channels = payload.side_channels.map(a => ({ ...a }));
    if (!shaft.side_channels) shaft.side_channels = [];
    shaft.side_channels.forEach(sideChannel => {
      if (!isUpdate) delete sideChannel.id;
      else sideChannel.shaft_id = payload.id;
      delete sideChannel.user_created;
      if (sideChannel.diameter && sideChannel.diameter.id)
        sideChannel.diameter = sideChannel.diameter.id;
      if (sideChannel.angle === '') sideChannel.angle = undefined;
    });
  } else shaft.side_channels = null;

  // buildup properties
  if (includeBuildup) {
    shaft.height = payload.height;
    shaft.cover = payload.cover;
    shaft.cone = payload.cone;
    if (shaft.cone && shaft.cone.id) shaft.cone = shaft.cone.id;
    if (shaft.cover && shaft.cover.id) shaft.cover = shaft.cover.id;
    if (payload.top_edge) {
      shaft.top_edge = payload.top_edge;
      shaft.top_edge = ('' + shaft.top_edge).replace(',', '.');
    }
    if (payload.bottom_edge) {
      shaft.bottom_edge = payload.bottom_edge;
      shaft.bottom_edge = ('' + shaft.bottom_edge).replace(',', '.');
    }
    shaft.clamp = payload.clamp;
    shaft.sealing = payload.sealing;
  } else {
    shaft.height = null;
    shaft.cover = null;
    shaft.cone = null;
    shaft.top_edge = null;
    shaft.bottom_edge = null;
    shaft.clamp = null;
    shaft.sealing = null;
  }

  // buildups
  if (includeBuildup && payload.buildups) {
    shaft.buildups = payload.buildups.map(a => ({ ...a }));
    if (!shaft.buildups) shaft.buildups = [];
    shaft.buildups.forEach(buildup => {
      if (!isUpdate) delete buildup.id;
      else buildup.shaft_id = payload.id;
      delete buildup.user_created;
      if (buildup.type && buildup.type.id) buildup.type = buildup.type.id;
    });
  } else shaft.buildups = [];

  //console.log('original shaft:');
  //console.log(payload);
  //console.log('duplicated shaft:');
  //console.log(shaft);
  return shaft;
};

export const calculateHeights = shaft => {
  var heights = {};

  // get max diameter for shaft base height calculation
  var maxDnItem = shaft.input_channel.diameter;
  if (shaft.output_channel && shaft.output_channel.diameter.dn > maxDnItem.dn) {
    maxDnItem = shaft.output_channel.diameter;
  }
  if (shaft.side_channels)
    shaft.side_channels.forEach(sideChannel => {
      if (sideChannel.diameter && sideChannel.diameter.dn > maxDnItem.dn) {
        maxDnItem = sideChannel.diameter;
      }
    });

  // calculate height for base
  heights.base = maxDnItem.height - maxDnItem.height_sole;
  heights.sole = maxDnItem.height_sole;

  // calculate heights for buildup
  var buildups = 0;
  shaft.buildups.forEach(buildup => {
    buildups += parseInt(buildup.type ? buildup.type.height : 0);
  });
  heights.buildups = buildups;

  // calculate heights for terrain
  heights.topEdge = shaft.top_edge
    ? parseFloat(('' + shaft.top_edge).replace(',', '.')) * 100 // in m -> convert to cm
    : 0;
  heights.bottomEdge = shaft.bottom_edge
    ? parseFloat(('' + shaft.bottom_edge).replace(',', '.')) * 100 // in m -> convert to cm
    : 0;

  // calculate heights for cover
  heights.cover = 0;
  if (shaft.cover) heights.cover = shaft.cover.height;

  // calculate heights for cone
  heights.cone = 60;
  if (shaft.cone) heights.cone = parseInt(shaft.cone.height);

  // general calculations
  heights.shaft =
    heights.cone + heights.cover + heights.sole + heights.buildups; // schachtabdeckung + konus + nutzhöhe + ringe
  heights.terrain = heights.topEdge - heights.bottomEdge;
  heights.diff = heights.shaft - heights.terrain;
  heights.max = Math.max(
    heights.shaft + heights.base,
    heights.terrain + heights.base,
  );

  //console.log(heights);

  return heights;
};

export const formatDate = date => {
  return new Date(date).toLocaleDateString('de-DE');
};

export const formatTime = date => {
  return new Date(date).toLocaleTimeString('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatDateTime = date => {
  return formatDate(date) + ' ' + formatTime(date);
};

export const userNamesVisible = shaft => {
  return !!(
    shaft?.site_id?.company?.users && shaft.site_id.company.users.length > 1
  );
};

export const getUserFullName = user => {
  if (!user) return '';
  let userObj = user;
  if (user.user) userObj = user.user;
  return userObj.id === store.getters.user.id
    ? 'mir'
    : `${userObj.first_name} ${userObj.last_name}`;
};

export const getLastEditedString = shaft => {
  var lastUpdatedUser = shaft.user_updated;
  if (lastUpdatedUser) lastUpdatedUser = getUserFullName(lastUpdatedUser);
  var str = `zuletzt bearbeitet von ${lastUpdatedUser}`;
  if (!shaft.ordered && lastUpdatedUser) return str;
  if (
    userNamesVisible(shaft) &&
    shaft.ordered &&
      shaft.user_updated &&
      shaft.order_user &&
      shaft.user_updated.id !== shaft.order_user.id
  )
    return str;
  return '';
};

export const getOrderDateString = shaft => {
  if (shaft.order_date)
    return `bestellt ${getOrderUserString(shaft)}am ${formatDate(
      shaft.order_date,
    )}`;
  return '';
};

export const getDeliveryDateString = shaft => {
  if (shaft.delivery_date)
    return `gewünschter Liefertermin am ${formatDate(shaft.delivery_date)}`;
  return '';
};

export const getOrderUserString = shaft => {
  if (!userNamesVisible(shaft)) return '';
  var orderUser = shaft.order_user;
  if (!orderUser) orderUser = shaft.user_updated;
  if (orderUser) orderUser = getUserFullName(orderUser);
  if (orderUser) return `von ${orderUser} `;
  return '';
};
